// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__iiiuc","info":"Note_info__cAAdq","note":"Note_note__2sIrN","actions":"Note_actions__3kRe0"};